import { render } from "./receiptInfo.vue?vue&type=template&id=3957605a&scoped=true"
import script from "./receiptInfo.vue?vue&type=script&lang=js"
export * from "./receiptInfo.vue?vue&type=script&lang=js"

import "./receiptInfo.vue?vue&type=style&index=0&id=3957605a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3957605a"]])

export default __exports__